import React, { createContext, useContext } from 'react';
import { createFetcher } from '../api/fetchData';

const ClientContext = createContext(null);

export function ClientProvider({ value, children }) {
  const fetcher = createFetcher(value.slug);
  return (
    <ClientContext.Provider value={{ ...value, fetcher }}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const ctx = useContext(ClientContext);
  if (!ctx) throw new Error('useClient must be used within ClientProvider');
  return ctx;
}
